import React, { Fragment } from "react";
import {
    AGE_GROUP_OPTIONS,
    GENDER_OPTIONS,
    LOCATION_OPTIONS,
} from "../../util/constants";
import { CloseIcon } from "../../util/icons";

export const FilterHeader = ({
    regions,
    adFormats,
    adShapes,
    setQueryVar,
    setRegionQueryVar,
    onClearFilter,
    variables,
}) => {
    const pills = [];
    const multiFilters = {
        regionIDs: regions,
        adFormatIDs: adFormats,
        adShapeIDs: adShapes,
    };
    for (let filter in multiFilters) {
        const selectedIDs = variables[filter];
        const objects = multiFilters[filter];
        selectedIDs.map((a) => {
            const object = objects.find((o) => o.id === a);
            if (object) {
                pills.push({
                    type: filter,
                    value: object.id,
                    label: object.title,
                });
            }
        });
    }

    const oneFilters = {
        gender: GENDER_OPTIONS,
        age: AGE_GROUP_OPTIONS,
        location: LOCATION_OPTIONS,
    };
    for (let filter in oneFilters) {
        const selectedValue = variables[filter];
        const objects = oneFilters[filter];
        const object = objects.find((o) => o.id === selectedValue);
        if (object) {
            pills.push({
                type: filter,
                value: object.id,
                label: object.title,
            });
        }
    }

    const onPillClose = (pill) => {
        if (pill.type === "regionIDs") {
            let { regionIDs, cityIDs } = variables;

            regionIDs = regionIDs.filter((v) => v !== pill.value);

            const thisRegion = regions.find((r) => r.id === pill.value);
            const thisCityIDs = thisRegion.cities.map((c) => c.id);
            if (thisRegion) {
                cityIDs = cityIDs.filter((n) => !thisCityIDs.includes(n));
            }

            setRegionQueryVar(regionIDs, cityIDs);
        } else {
            const isMultiple = multiFilters.hasOwnProperty(pill.type);
            setQueryVar(pill.type, isMultiple ? pill.value : "", isMultiple, multiFilters[pill.type]);
        }
    };

    return (
        <Fragment>
            <div className="planner-filter__head">
                <div className="planner-filter__filter-icon">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 17.5 16.292"
                    >
                        <path
                            id="Path_15"
                            fill-rule="evenodd"
                            stroke="#000"
                            stroke-width=".5"
                            d="M17.25 2.682h-3.1A3.036 3.036 0 0 0 11.175.25 3.036 3.036 0 0 0 8.2 2.682H.25v1.214h7.954a3.036 3.036 0 0 0 2.975 2.432 3.036 3.036 0 0 0 2.975-2.432h3.096Zm-6.071 2.429A1.822 1.822 0 0 1 9.358 3.29a1.822 1.822 0 0 1 1.821-1.821A1.822 1.822 0 0 1 13 3.29a1.822 1.822 0 0 1-1.821 1.821ZM.25 13.611h3.1a3.036 3.036 0 0 0 2.975 2.432A3.036 3.036 0 0 0 9.3 13.611h7.95v-1.214H9.296a3.036 3.036 0 0 0-2.975-2.432 3.036 3.036 0 0 0-2.975 2.432H.25Zm4.25-.607a1.821 1.821 0 0 1 1.821-1.821 1.821 1.821 0 0 1 1.821 1.821 1.821 1.821 0 0 1-1.821 1.821A1.821 1.821 0 0 1 4.5 13.003Z"
                            data-name="Path 15"
                        />
                    </svg>
                    <h4>{"Filter"}</h4>
                </div>
                {!!pills.length && (
                    <button onClick={onClearFilter}>{"Clear All"}</button>
                )}
            </div>

            {!!pills.length && (
                <div className="planner-filter__applied">
                    {pills.map((pill) => (
                        <div
                            className="planner-filter__pill"
                            onClick={() => onPillClose(pill)}
                        >
                            <p>{pill.label}</p>
                            <CloseIcon />
                        </div>
                    ))}
                </div>
            )}
        </Fragment>
    );
};
